import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

//components
import UploadedFiles from './UploadedFiles';
import UpdateProject from './UpdateProject';
import { TabMenu } from 'primereact/tabmenu';
import UpdateProjectPrompt from './UpdateProjectPrompt';

//api
import { ProjectManagementService } from '../../service/projectmanagement-service';

const ProjectManagement = () => {
  const { id } = useParams();
  const { setValue } = useForm();
  const [project, setProject] = useState();
  // eslint-disable-next-line no-unused-vars
  const [reloadList, setReloadList] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);


  //chiamata GET
  useEffect(() => {
    const fetchProject = () => {
      ProjectManagementService.getProject(id, (data) => {
        setProject(data);
        setValue('name', project.name);
        setValue('notes', project.notes);
      });
    };

    fetchProject();
  }, [id]);

  const items = [
        { label: 'Modifica', icon: 'pi pi-pen-to-square' },
        { label: 'Prompt', icon: 'pi pi-align-left' },
        { label: 'File di Analisi', icon: 'pi pi-file' },
  ];

  return (
    <div>
      <h1>Gestione Progetto: {project?.name}</h1>
      <div className="projectManagement__Wrapper">
        <div className="projectManagement__Components">
          <div>
            <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
          </div>
          <div>
            {activeIndex === 0 && (
            <UpdateProject projectId={id} project={project} />
          )}
          {activeIndex === 1 && (
            <UpdateProjectPrompt projectId={id} project={project} />
          )}

          {activeIndex === 2 && (
            <UploadedFiles projectId={id} reloadList={reloadList} />
          )}
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default ProjectManagement;
